import React, { createContext } from "react";
import {
  CurrentCountContextType,
  StockCountContextValue,
  StockCountHistoryContextType,
  StockCountItemSyncContextType,
  StockCountSearchContextType,
  StockCountTabContextType,
  StockCountSyncContextType,
} from "./types";
import StockCount from "../data/model/StockCount";

export const StockCountContext = createContext<StockCountContextValue | null>(
  null
);

export const CurrentCountContext = React.createContext<
  CurrentCountContextType | undefined
>(undefined);

export const StockCountSearchContext = React.createContext<
  StockCountSearchContextType | undefined
>(undefined);

export const StockCountSyncContext = React.createContext<
  StockCountSyncContextType | undefined
>(undefined);

export const StockCountItemSyncContext = React.createContext<
  StockCountItemSyncContextType | undefined
>(undefined);

export const StockCountHistoryContext = React.createContext<
  StockCountHistoryContextType | undefined
>(undefined);

export const StockCountTabContext = React.createContext<
  StockCountTabContextType | undefined
>(undefined);

export const CountProductModalRootContext = React.createContext<
  | {
      stockCount: StockCount;
    }
  | undefined
>(undefined);
